import { routerReducer } from '@ngrx/router-store';

import { uiReducer } from './ui/index';
import { mainReducer } from './main/index';
import { userReducer } from './user/index';
import { staticReducer } from './static/index';
import { listReducer } from './list/index';

export const reducer = {
  router: routerReducer,
  static: staticReducer,
  ui: uiReducer,
  main: mainReducer,
  user: userReducer,
  list: listReducer,

}



// WEBPACK FOOTER //
// ./src/app/store/app-reducer.ts